"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.LineAligned = void 0;

var _jsxRuntime = require("react/jsx-runtime");

var _react = require("@fluentui/react");

var React = _interopRequireWildcard(require("react"));

var getClassNames = (0, _react.classNamesFunction)();
/**
 * This component is guaranteed to be one text line high (at the inherited font
 * size and line height), and its content will be vertically centered to that
 * line. This allows for aligning icons, etc. which may not normally be the
 * same hight as the text.
 */

var LineAlignedBase = function LineAlignedBase(_ref) {
  var className = _ref.className,
      styles = _ref.styles,
      children = _ref.children;
  var classes = getClassNames(styles);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: (0, _react.css)('ms-LineAligned', className, classes.root),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: (0, _react.css)('ms-LineAligned--content', classes.content),
      children: children
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: (0, _react.css)('ms-LineAligned--spacer', classes.spacer),
      children: "\xA0"
    })]
  });
};

var LineAligned = (0, _react.styled)(LineAlignedBase, {
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    flex: '0 0 auto'
  },
  content: {
    // Effectively zero hight.
    margin: '-50% 0'
  },
  spacer: {
    width: 0,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    visibility: 'hidden'
  }
});
exports.LineAligned = LineAligned;